(function() {

  'use strict';

  // date

  var date = new Date(),
      month = date.getMonth() + 1,
      day = date.getDate();



  if (month === 12) {

    for (var i = 0; i < day; i++) {
      $('.day-' + i).addClass('active open');
    }

    var $day = $('.day-' + day);

    $day.on('click', function() {
      $day.addClass('active');
    });

  }

  $('.active').on('click', function() {
    var $this = $(this);

    if ($this.hasClass('open')) {
      $this.removeClass('open');
    } else {
      $this.addClass('open');
    }

  });

  $('.day-' + day).on('click', function() {
    var $this = $(this);
    if ($this.hasClass('open')) {
      $this.removeClass('open');
    } else {
      $this.addClass('open');
    }
  });

})();